module.exports = __webpack_public_path__ + "img/2022-teachers-day.02db21fb.jpg";